const mounted = {
  mounted () {
    // if (this.$store.state.isForceUpdateOne) {
    //   this.$forceUpdate();// 强行渲染
    //   this.$set(this.$store.state, 'isForceUpdateOne', false);
    // }
  },
};

export default mounted;



// WEBPACK FOOTER //
// src/util/updateView.js